import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { UtilService } from '../../../shared/services';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AvatarComponent implements OnInit {

  @Input() name;
  @Input() image;
  @Input() size = '48px';
  @Input() fontsize = '17px';
  ininame;
  constructor(
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.getInitialsOfName(this.name);
  }

  /**
   * Get Initials of name
   * But only two initials
   * @param name Name
   */
  getInitialsOfName(name: string): void {
    if (name) {
      const data = name ? name.split(' ') : [];
      if (data.length > 1) {
        this.ininame =  data[0].charAt(0) + data[1].charAt(0);
      } else {
        this.ininame =  data[0].charAt(0).trim();
      }
    }
  }


}
